import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { COUNTRIES, flagUrl } from "../../lib/shield";
import { COUNTIES, PROVINCES, flagKind, countyBadgeUrl, provinceBadgeUrl } from "../../lib/regions";

const trigger = "h-11 rounded-none border-2 border-slate-200 font-semibold";
const Option = ({ value, src, name, testId }) => (
  <SelectItem value={value} data-testid={testId}>
    <span className="flex items-center gap-2"><img src={src} alt="" className="h-3.5 w-5 object-cover" />{name}</span>
  </SelectItem>
);

const TITLES = { country: "Country flag", county: "County", province: "Province" };
export const flagTitle = (sport, flag) => TITLES[flagKind(sport, flag)];

export const FlagPicker = ({ sport, flag, onFlag }) => {
  const kind = flagKind(sport, flag);
  const tabs = ["country", ...(["gaa", "hurling"].includes(sport) ? ["county"] : []), "province"];
  return (
    <div className="space-y-3">
      <div className={`grid gap-1 ${tabs.length === 3 ? "grid-cols-3" : "grid-cols-2"}`} role="radiogroup" aria-label="Flag type">
        {tabs.map((k) => (
          <button key={k} type="button" role="radio" aria-checked={kind === k} onClick={() => onFlag({ ...flag, kind: k })} data-testid={`flag-kind-${k}`}
            className={`py-2 text-xs font-bold uppercase ${kind === k ? "bg-slate-900 text-white" : "border-2 border-slate-200 hover:border-slate-900"}`}>{TITLES[k]}</button>
        ))}
      </div>
      {kind === "country" && (
        <Select value={flag.code} onValueChange={(code) => onFlag({ ...flag, code })}>
          <SelectTrigger className={trigger} data-testid="flag-select"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72">{COUNTRIES.map(([c, n]) => <Option key={c} value={c} src={flagUrl(c)} name={n} testId={`flag-option-${c}`} />)}</SelectContent>
        </Select>
      )}
      {kind === "county" && (
        <Select value={flag.county || "ker"} onValueChange={(county) => onFlag({ ...flag, county })}>
          <SelectTrigger className={trigger} data-testid="county-select"><SelectValue /></SelectTrigger>
          <SelectContent className="max-h-72">{COUNTIES.map(([c, n]) => <Option key={c} value={c} src={countyBadgeUrl(c)} name={n} testId={`county-option-${c}`} />)}</SelectContent>
        </Select>
      )}
      {kind === "province" && (
        <Select value={flag.province || "mun"} onValueChange={(province) => onFlag({ ...flag, province })}>
          <SelectTrigger className={trigger} data-testid="province-select"><SelectValue /></SelectTrigger>
          <SelectContent>{PROVINCES.map(([c, n]) => <Option key={c} value={c} src={provinceBadgeUrl(c)} name={n} testId={`province-option-${c}`} />)}</SelectContent>
        </Select>
      )}
      {kind !== "country" && <p className="text-xs text-slate-500">Shown in {kind === "county" ? "county" : "provincial"} colours with a short code{kind === "province" ? " – based on the provincial flag" : ""}.</p>}
    </div>
  );
};
